var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIconsLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#socialIcons - LinkedIn__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.816.632H1.18C.528.632 0 1.148 0 1.785v13.691a1.17 1.17 0 0 0 1.181 1.156h13.635c.653 0 1.184-.519 1.184-1.153V1.785c0-.637-.531-1.153-1.184-1.153ZM4.746 14.267H2.373V6.629h2.375v7.638ZM3.56 5.589a1.376 1.376 0 1 1-.004-2.752 1.376 1.376 0 0 1 .004 2.752Zm10.075 8.678h-2.372v-3.713c0-.884-.015-2.025-1.234-2.025-1.234 0-1.422.966-1.422 1.963v3.775h-2.37V6.629h2.275v1.044h.032c.315-.6 1.09-1.234 2.243-1.234 2.404 0 2.847 1.58 2.847 3.637v4.19Z",
    fill: "#FCFCFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "socialIcons - LinkedIn__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .632)",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconsLinkedIn);
export default __webpack_public_path__ + "static/media/socialIcons - LinkedIn.1b89ded619312998023fb7a0347ab9a9.svg";
export { ForwardRef as ReactComponent };